import script from "./ClientAddWorkerDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientAddWorkerDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ClientAddWorkerDropdown.vue?vue&type=style&index=0&id=ea6e5e3a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea6e5e3a"]])

export default __exports__